import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCreditsStore from '../../../Store/Credits';
import { StyledDiv, StyledInfiniteScroll } from '../../../Theme/CommonStyled';
import LoadingSpinner from '../../Common/LoadingSpinner';
import useLandingStore from '../../../Store/Landing';
import CreditCard from '../CreditCard';
import { StyledCreditHistoryLink } from './style';
import Icon from '../../Common/Icon';
import { isValid } from '../../../Utils/common.util';
import LoadingBox from '../../Common/LoadingBox';

type CreditsListType = {
  branchId?: number;
  sortOrder?: string;
  listType?: string;
};
const CreditsList: React.FC<CreditsListType> = ({
  branchId = 0,
  sortOrder,
  listType = 'active'
}) => {
  const { t } = useTranslation();
  const landingData = useLandingStore((state) => state.landingData);
  const activeCreditListData = useCreditsStore(
    (state) => state.activeCreditListData
  );
  const getCreditListAction = useCreditsStore(
    (state) => state.getCreditListAction
  );
  const expiredCreditListData = useCreditsStore(
    (state) => state.expiredCreditListData
  );
  const usedCreditListData = useCreditsStore(
    (state) => state.usedCreditListData
  );
  const creditsListLoading = useCreditsStore(
    (state) => state.creditsListLoading
  );
  const hasMoreData = useCreditsStore((state) => state.hasMoreData);
  const setHasMoreDataAction = useCreditsStore(
    (state) => state.setHasMoreDataAction
  );
  const dataLength = useCreditsStore((state) => state.dataLength);
  const setDataLength = useCreditsStore((state) => state.setDataLength);

  const currentListData =
    listType === 'active'
      ? activeCreditListData
      : listType === 'used'
      ? usedCreditListData
      : expiredCreditListData;

  const getMoreData = (isFilterChanged?: boolean): void => {
    setTimeout(async () => {
      const response = await getCreditListAction(
        listType,
        {
          clubBranchId: branchId,
          skip: dataLength - 10,
          take: 10,
          uniqueId: landingData?.uniqueId,
          orderBy: sortOrder
        },
        isFilterChanged
      );

      if (response !== 10) {
        setDataLength(10);
        setHasMoreDataAction({
          ...hasMoreData,
          [listType]: false
        });
      } else {
        setDataLength(dataLength + 10);
        setHasMoreDataAction({
          ...hasMoreData,
          [listType]: true
        });
      }
    }, 500);
  };
  useEffect(() => {
    isValid(branchId) && sortOrder && getMoreData(true);
  }, [branchId, sortOrder, listType]);

  return (
    <LoadingBox loading={creditsListLoading}>
      <StyledDiv mb={9}>
        <StyledInfiniteScroll
          scrollableTarget="main-container"
          next={getMoreData}
          endMessage={
            <>
              {currentListData.length === 0 && !creditsListLoading && (
                <StyledDiv
                  textAlign="center"
                  fontSize={4}
                  py={9}
                  color="minorText">
                  {t('credits.itemNotFound')}
                </StyledDiv>
              )}
              {listType === 'active' && (
                <StyledCreditHistoryLink
                  to="/creditsHistory"
                  onClick={() => {
                    setDataLength(10);
                  }}>
                  {t('credits.creditHistory')}
                  <Icon name="enter-1" fontSize={2} color="primaryBlue" />
                </StyledCreditHistoryLink>
              )}
            </>
          }
          loader={
            currentListData.length > 0 && (
              <StyledDiv
                width="100%"
                display="flex"
                justifyContent="center"
                my={8}>
                <LoadingSpinner
                  width={'20px'}
                  height={'20px'}
                  type="primaryGreen"
                />
              </StyledDiv>
            )
          }
          hasMore={hasMoreData[listType]}
          dataLength={dataLength}>
          {currentListData.map((item) => (
            <CreditCard key={item.code} data={item} cardType={listType} />
          ))}
        </StyledInfiniteScroll>
      </StyledDiv>
    </LoadingBox>
  );
};

export default CreditsList;
